import clsx from 'clsx'
import { KTIcon } from '../../../helpers'
import { HeaderNotificationsMenu, HeaderUserMenu } from '../../../partials'
import { LanguagesNavbar } from '../../../partials/layout/header-menus/Languages'
import { useLayout } from '../../core'
import { getProfile } from '../../../../app/modules/auth/core/_requests'
import Clock from './Clock'
import { axiosClientAuth } from '../../../../app/utils'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px position-relative'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

export interface NotificationData {
  id: number
  event_type: string
  resource_type: string
  resource_id: string
  actor: string | null
  title: string
  message: string
  meta: Record<string, any> | null
  created_at: string
}

const Navbar = () => {
  const { config } = useLayout()
  const { data: profile } = useQuery(
    'auth-profile',
    () => getProfile().then((r) => r.data?.data),
    { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  )
  const [notificationData, setNotificationData] = useState<NotificationData[]>([])
  const nav = useNavigate()
  const theme = localStorage.getItem('kt_theme_mode_value')

  const fetchNotifications = () => {
    axiosClientAuth.get('/notifications/')
      .then((res) => {
        setNotificationData(res.data.data.results || [])
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  const handleNotificationNavigate = (resourceType: string) => {
    nav(navigateTo(resourceType))
  }

  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)} onClick={fetchNotifications}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='notification' className={`${btnIconClass} ${theme == 'light' ? "text-white" : "text-white"}`} />
          {notificationData.length > 0 &&
            theme == 'light' ? <span className='badge badge-circle bg-warning h-20px w-20px position-absolute translate-middle top-25 start-75 animation-blink'>{notificationData.length}
          </span> :
            <span className='badge badge-circle bg-warning text-black h-20px w-20px position-absolute translate-middle top-25 start-75 animation-blink'>{notificationData.length}
            </span>
          }
        </div>
        <HeaderNotificationsMenu
          notificationData={notificationData}
          handleNotificationNavigate={handleNotificationNavigate}
        />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <LanguagesNavbar />
      </div>
      <div className='d-flex gap-4'>
        <Clock />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div
            className='d-flex align-items-center justify-content-center symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'
            style={{ height: '35px', width: '35px', backgroundColor: '#E8912D', fontSize: '20px', fontWeight: 600 }}
          >
            {profile?.name?.substr(0, 1)?.toUpperCase()}
          </div>
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export { Navbar }

const navigateTo = (resourceType: string): string => {
  switch (resourceType) {
    case 'url':
      return 'urlverification'
    case 'template_mapping':
      return 'managetemplate'
    case 'ip_address':
      return 'iplist'
    case 'route':
    case 'route_hop':
      return 'smsreport'
    default:
      return 'dashboard'
  }
}
